import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, InputNumber } from 'antd';
import { Prompt } from 'react-router';

import { HeaderView } from 'src/app/shared/header.view';
import { CardController } from 'src/app/shared/card.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { TextView } from 'src/core/ui/text.view';
import TimeSelecter from './timeselecter';

interface ProductProviderFormViewProps extends ComponentViewProps<ProductProviderItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class ProductProviderFormView extends React.Component<ProductProviderFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		const model = this.props.model;

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				{
					this.props.save &&
					<Row>
						<Col span={24}>
							<HeaderView
								title={this.props.title}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								save={this.props.save}
								cancel={this.props.cancel}
								contextService={this.props.contextService}
							/>
						</Col>
					</Row>
				}
				<Row>
					<Col span={24}>
						<CardController
							icon="book"
							title="General information"
							mode={this.props.mode}>
							<Row gutter={24}>
								<Col xs={16}>
									<TextView mode={this.props.mode}
										required
										onGetErrorMessage={() => this.props.model.validate(false, 'name')}
										label="Name"
										value={model.name}
										onChanged={newVal => {
											model.name = newVal;
										}}
									/>

								</Col>
							</Row>
							<Row gutter={24}>
								<Col xs={8}>

									<label> Max request count</label>
									<br/>
									<InputNumber
										 min={1} max={100} value={model.requestLimits} onChange={(e: number) => {
										model.requestLimits = e;
									}} disabled={this.props.mode == 'display'} />

								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForAccommodation}
										label="Accommodation"
										onChanged={newVal => model.isActiveForAccommodation = newVal}
										mode={model.isActiveForApiAccommodation == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForAccommodation}
										onChanged={newVal => model.cacheTimeForAccommodation = newVal}
										mode={model.isActiveForAccommodation == false ? 'display' : this.props.mode }
									/>
								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForCarRent}
										label="Car Rent"
										onChanged={newVal => model.isActiveForCarRent = newVal}
										mode={model.isActiveForApiCarRent == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForCarRent}
										onChanged={newVal => model.cacheTimeForCarRent = newVal}
										mode={model.isActiveForCarRent == false ? 'display' : this.props.mode}
									/>
								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForFlight}
										label="Flight"
										onChanged={newVal => model.isActiveForFlight = newVal}
										mode={model.isActiveForApiFlight == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForFlight}
										onChanged={newVal => model.cacheTimeForFlight = newVal}
										mode={model.isActiveForFlight == false ? 'display' : this.props.mode}
									/>
								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForGeneral}
										label="General"
										onChanged={newVal => model.isActiveForGeneral = newVal}
										mode={model.isActiveForApiGeneral == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForGeneral}
										onChanged={newVal => model.cacheTimeForGeneral = newVal}
										mode={model.isActiveForGeneral == false ? 'display' : this.props.mode}
									/>
								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForTransfer}
										label="Transfer"
										onChanged={newVal => model.isActiveForTransfer = newVal}
										mode={model.isActiveForApiTransfer == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForTransfer}
										mode={model.isActiveForTransfer == false ? 'display' : this.props.mode}
										onChanged={newVal => model.cacheTimeForTransfer = newVal}
									/>
								</Col>
							</Row>
							<Row>
								<Col span={6}>
									<BooleanView
										value={model.isActiveForTour}
										label="Tour"
										onChanged={newVal => model.isActiveForTour = newVal}
										mode={model.isActiveForApiTour == false ? "display" : this.props.mode}
									/>
								</Col>
								<Col span={6}>
									<TimeSelecter
										time={model.cacheTimeForTour}
										mode={model.isActiveForTour == false ? 'display' : this.props.mode}
										onChanged={newVal => model.cacheTimeForTour = newVal}
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/form/product-provider-form.view.tsx